import { useTheme } from '@emotion/react';
import { mapValues, isFunction } from 'radash';
import { useMemo } from 'react';
import * as index from './mixins/index.js';

/**
 * Hook to access CSS mixins based on the current theme.
 */ function useCssMixins() {
    const theme = useTheme();
    return useMemo(()=>mapValues(index, (value)=>resolveCss(theme, value)), [
        theme
    ]);
}
/**
 * Resolves an interpolation function to a CSS object. Ideally, Emotion would allow callbacks with
 * the theme object anywhere in the CSS tree. However, they are only allowed at the root level, so
 * we will instead resolve any callbacks to a CSS interpolation object.
 *
 * @param theme - The theme object.
 * @param mixin - The mixin function.
 */ function resolveCss(theme, mixin) {
    return (...args)=>{
        const interpolation = mixin(...args);
        return isFunction(interpolation) ? interpolation(theme) : interpolation;
    };
}

export { useCssMixins };
//# sourceMappingURL=use-css-mixins.js.map
